import http from 'core/services/http';
import Config from 'core/config';
import { isObject } from 'lodash';
import moment from 'moment';
import { toQueryString } from 'shared/helpers';
import { DATE_FORMATS } from 'shared/constants';
import axios from 'axios';

class RostersService {
  static getTcEventExamineeCount(tcEventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${tcEventId}/assignedstatus`);
  }

  static getLocationEventExamineeCount(locationEventId) {
    return http.get(`${Config.apiUrl}/locationevent/${locationEventId}/assignedstatus`);
  }

  static getEventExamineeCount(locations) {
    return axios.all(locations.map(location =>
      RostersService.getLocationEventExamineeCount(location.locationEvent.id).then((result)=> ({ list:result, locationEventId: location.locationEvent.id}))));
  }

  static getLocationEventRoomRosters(locationEventId) {
    return http.get(`${Config.apiUrl}/locationevent/${locationEventId}/roomrosters`);
  }

  static getLocationEventExaminees(locationEventId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/locationevent/${locationEventId}/registrations${queryString}`);
  }

  static getExamineeDetails(examineeId) {
    return http.get(`${Config.apiUrl}/registration/${examineeId}`);
  }

  static getExamineePhoto(examineeId) {
    return http.get(`${Config.apiUrl}/registration/${examineeId}/photo`,{responseType: 'arraybuffer'});
  }

  static getCompatibleRooms(locationEventId, examineeList, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.post(`${Config.apiUrl}/locationevent/${locationEventId}/compatiblerooms${queryString}`, examineeList);
  }

  static assignExamineesToRoom(roomId, list) {
    return http.put(`${Config.apiUrl}/room/${roomId}/assignregtoroom`, list);
  }

  static unassignExaminees(locationEvId, list) {
    return http.put(`${Config.apiUrl}/locationevent/${locationEvId}/unassignregs`, list);
  }

  static getEventRostersPdfUUID(eventId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/rosterspdf${queryString}`);
  }

  static getEventRostersPdf(eventId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/rosterurl${queryString}`);
    // return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/rosterspdf${queryString}`, {
    //   responseType: 'blob',
    // }).then((response) => {
    //   const url = window.URL.createObjectURL(new Blob([response]));
    //   const link = document.createElement('a');
    //   const pdfName = params.checkin ? (params.namesonly ? '' : ' Photo') : ' Names Only';
    //   link.href = url;
    //   link.setAttribute('download', `ACT Roster${pdfName} ${moment().format(DATE_FORMATS.monthDayYearDash)}.pdf`);
    //   document.body.appendChild(link);
    //   link.click();
    // });
  }

  static getTcEventExamCategories(tcEvId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${tcEvId}/examcategories`);
  }

  static getRescheduleDates(tcEvId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/testcenterevent/${tcEvId}/rescheduledate${queryString}`);
  }

  static getAuthorizationTickets(data) {
    return http.post(`${Config.apiUrl}/onlinereg/authTestCenterPdf/generate`, data);
  }
}


export default RostersService;
